import partnerSpendLogRepository from '@/repository/generatedRepository/partnerSpendLogRepository'
import TableOptions from '@/models/TableOptions'
import { omitEmptyFilters, prepareFilters } from '@/helpers/filters'
import StorageService from '@/services/storage.service'
import storageKeys from '@/constants/storageKeys'
import { defaultFilters } from '@/models/PartnerSpendLog/helpers'
import { downloadExportFile } from '@/helpers/export'

const state = {
  list: [],
  filters: StorageService.get(storageKeys.PARTNER_SPEND_LOG_FILTERS) || { ...defaultFilters() },
  tableOptions: TableOptions.defaultTableOptions(),
}

const getters = {
  list: state => state.list,
  preparedItems: state => state.list.flatMap((item, itemIndex) => {
    const changeEntries = item.changes && Object.keys(item.changes).length
      ? Object.entries(item.changes)
      : [[null, { old: null, new: null }]]

    return changeEntries.map(([key, change], changeIndex) => ({
      ...item,
      _id: `${itemIndex}-${changeIndex}`,
      authorName: item.createdBy?.fullName || null,
      authorId: item.createdBy?.id || null,
      streamTitle: item.stream?.title || '-',
      partnerGroupTitle: item.partnerGroup?.title || '-',
      siteId: item.stream?.siteId || '',
      advertiserTitle: item.advertiser?.title || '-',
      advertiserId: item.advertiser?.id,
      countryTitle: item.country?.title || '-',
      countryId: item.country?.id || null,
      propertyKey: key,
      valueBefore: change.old,
      valueAfter: change.new,
    }))
  }),
  filters: state => state.filters,
  tableOptions: state => state.tableOptions,
  isOpenFilterPanel: state =>
    state.filters.clientOptions && state.filters.clientOptions.filterPanelExpanded,
}

const actions = {
  async loadData(context, filters) {
    context.commit('setFilters', filters)
    StorageService.set(storageKeys.PARTNER_SPEND_LOG_FILTERS, filters)

    const appliedFilters = omitEmptyFilters(filters.filter)

    const preparedFilters = prepareFilters({
      ...filters,
      ...appliedFilters,
    })
    delete preparedFilters.filter

    const { data } = await partnerSpendLogRepository.list(preparedFilters)

    context.commit('setList', { data, filters })

    return { items: data.items, pagination: data.pagination }
  },
  async loadExportFile(context, filters) {
    const appliedFilters = omitEmptyFilters(filters.filter)

    const preparedFilters = prepareFilters({
      ...filters,
      ...appliedFilters,
    })
    delete preparedFilters.filter

    await downloadExportFile(partnerSpendLogRepository.exportPartnerSpendLogToken(preparedFilters))
  },
  updateFiltersClientOptions({ commit, getters }, clientOptions) {
    const updatedFilters = {
      ...getters.filters,
      clientOptions,
    }
    commit('setFilters', updatedFilters)
    StorageService.set(storageKeys.PARTNER_SPEND_LOG_FILTERS, updatedFilters)
  },
  filtersStorageReset() {
    StorageService.remove(storageKeys.PARTNER_SPEND_LOG_FILTERS)
  },
}

const mutations = {
  setList(state, { data, filters }) {
    state.list = [...data.items]
    state.tableOptions = new TableOptions(data.pagination, filters)
  },
  setFilters(state, filters) {
    state.filters = { ...filters }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
